import { render, staticRenderFns } from "./AstroCalendarDownload.vue?vue&type=template&id=7b2fda2b&scoped=true&"
import script from "./AstroCalendarDownload.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarDownload.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarDownload.vue?vue&type=style&index=0&id=7b2fda2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fda2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2fda2b')) {
      api.createRecord('7b2fda2b', component.options)
    } else {
      api.reload('7b2fda2b', component.options)
    }
    module.hot.accept("./AstroCalendarDownload.vue?vue&type=template&id=7b2fda2b&scoped=true&", function () {
      api.rerender('7b2fda2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarDownload.vue"
export default component.exports